import {
  removeHeadingSlash, removeTrailingSlash, removeTrailingSymbols, trimSlashes,
} from "../stringUtils";

/**
 * Канонический абсолютный URL страницы.
 *
 * Вынесено из `SeoHeaders` в общий модуль, потому что этот же адрес служит основой `@id`
 * для узлов JSON-LD (`#webpage`, `#breadcrumb`, задача SEO #13). Считался бы он в двух местах
 * по-разному — узлы графа перестали бы ссылаться друг на друга, причём молча: разметка
 * осталась бы валидной, но связь между страницей и её «хлебными крошками» пропала бы.
 */
export const buildCanonicalUrl = (url: string): string =>
  trimSlashes(
    `${removeTrailingSlash(process.env.GATSBY_WEBSITE_URL || "https://lunaro.ru")}`
    + `/${removeHeadingSlash(removeTrailingSymbols(url))}`,
  );
